import { Component, HostListener, inject } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { ActivatedRoute, RouterLink, RouterOutlet } from '@angular/router';

import { DashboardHeaderComponent } from './dashboard-header/dashboard-header.component';
import { IInstitutionContext } from './models';
import {
  BaseDirective,
  DashboardService,
  DialogScrollService,
  ToastContainerComponent,
} from './shared';

@Component({
  selector: 'app-wrapper',
  imports: [
    DashboardHeaderComponent,
    RouterLink,
    RouterOutlet,
    ToastContainerComponent,
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent extends BaseDirective {
  route = inject(ActivatedRoute);
  public dashboardService = inject(DashboardService);
  private meta = inject(Meta);
  private dialogScrollService = inject(DialogScrollService);

  abbreviation: string;
  customFooterContent: string[];
  hideAaFooter: boolean;
  hasFi: boolean;

  contactEmail: string;
  contactUrl: string;
  contactText: string;

  @HostListener('click') onClick() {
    setTimeout(() => {
      const dialogs = document.getElementsByTagName('dialog');
      if (dialogs && dialogs.length === 0) {
        this.dialogScrollService.dialogClosed();
      }
    }, 100);
  }

  @HostListener('window:keyup', ['$event']) onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Escape' || event.key === 'Enter') {
      setTimeout(() => {
        const dialogs = document.getElementsByTagName('dialog');
        if (dialogs && dialogs.length === 0) {
          this.dialogScrollService.dialogClosed();
        }
      }, 100);
    }
  }

  constructor() {
    super();

    this._subscriptions.push(
      this.route.data.subscribe((data) => {
        const context: IInstitutionContext = data['context'];
        this.customFooterContent = context.customFooterContent;
        this.hideAaFooter = context.hideAaFooter;
        this.abbreviation = context.institutionAbbreviation;
        this.contactEmail = context.contactEmail;
        this.contactUrl = context.contactUrl;
        this.contactText = context.contactText;
        this.hasFi = context.hasFi;

        if (context.metaTags && context.metaTags.length > 0) {
          context.metaTags.forEach((t) => {
            this.meta.addTag({ name: t.key, content: t.value });
          });
        }
      }),
    );
  }
}
